import React from "react";
import { experience } from "../../mock";

const SectionLabel = ({ index, title }) => (
  <div className="flex items-center gap-3 mb-10">
    <span className="font-mono text-[11px] tracking-[0.22em] text-[#B8542B]">
      {index}
    </span>
    <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-[#6B5F52]">
      {title}
    </span>
    <span className="flex-1 h-px bg-[#E8E0D3]" />
  </div>
);

const Experience = () => {
  return (
    <section
      id="experience"
      className="py-24 md:py-32 px-6 md:px-10 bg-[#F5F0E8]/55"
    >
      <div className="max-w-6xl mx-auto">
        <SectionLabel index="02" title="Experience" />

        <div className="grid md:grid-cols-12 gap-8 md:gap-10 mb-14">
          <h2 className="md:col-span-7 font-serif text-3xl md:text-5xl text-[#1F1B16] leading-[1.1] tracking-tight">
            Five years. Three companies. One <span className="italic text-[#8a5a3d]">obsession</span>: software people can trust.
          </h2>
          <p className="md:col-span-5 text-[#6B5F52] text-base leading-relaxed md:pt-4">
            From Oracle Fusion regression suites at Tesco to wiring agentic AI into test design at JPMorgan — every role has been a chapter in the same craft: making quality feel inevitable.
          </p>
        </div>

        <ol className="relative">
          {experience.map((job, i) => (
            <li
              key={job.company}
              className="group grid md:grid-cols-12 gap-6 md:gap-10 py-8 md:py-10 border-t border-[#E8E0D3] last:border-b"
            >
              <div className="md:col-span-3">
                <div className="font-mono text-[11px] uppercase tracking-[0.18em] text-[#8a7d6e]">
                  {job.period}
                </div>
                <div className="mt-2 text-[13px] text-[#6B5F52]">
                  {job.location}
                </div>
                <div className="mt-4 font-mono text-[10px] text-[#B8542B]">
                  {String(experience.length - i).padStart(2, "0")} / {String(experience.length).padStart(2, "0")}
                </div>
              </div>

              <div className="md:col-span-9">
                <h3 className="font-serif text-2xl md:text-[28px] text-[#1F1B16] leading-tight">
                  {job.role}
                </h3>
                <div className="mt-1 font-serif text-[20px] md:text-[22px] text-[#8a5a3d] italic">
                  {job.company}
                </div>

                <p className="mt-4 text-[#3a342d] text-[15.5px] leading-relaxed max-w-2xl">
                  {job.summary}
                </p>

                <ul className="mt-5 space-y-2">
                  {job.highlights.map((h) => (
                    <li
                      key={h}
                      className="flex gap-3 text-[#3a342d] text-[14.5px] leading-relaxed"
                    >
                      <span className="mt-2 inline-block w-1.5 h-1.5 rounded-full bg-[#B8542B] flex-shrink-0" />
                      <span>{h}</span>
                    </li>
                  ))}
                </ul>

                <div className="mt-5 flex flex-wrap gap-2">
                  {job.stack.map((s) => (
                    <span
                      key={s}
                      className="font-mono text-[11px] px-2.5 py-1 rounded border border-[#E8E0D3] bg-[#FAF7F2] text-[#6B5F52]"
                    >
                      {s}
                    </span>
                  ))}
                </div>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default Experience;
